
import React, { useEffect, useState } from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, Grid, Paper, useMediaQuery, Button, FormHelperText } from '@mui/material';
import styled, { inputStyles } from '../../Utils/inputChanges';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { errorStyles } from '../../Utils/table';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSinglePanna, updatePannaEntry } from '../../Store/PHPSlice/Panna';


const PannaEdit = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        panaId: parseInt(Id),
        panna_size: '',
        userId: userdata?.ID
    });
    const dispatch = useDispatch();
    const singlePana = useSelector((state) => state.PannaData.singlePana || { data: [] });
    useEffect(() => {
        dispatch(fetchSinglePanna(Id));
    }, [dispatch])
    useEffect(() => {
        if (singlePana.data.length > 0) {
            const item = singlePana.data[0];
            setFormData({
                ...formData,
                panna_size: item.panna_size
            });
        }
    }, [singlePana]);
    const [errors, setErrors] = useState({});
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (value > 0 || value === '') {
            setFormData({
                ...formData,
                [name]: value
            });
        }
    };


    const handleSubmit = (event) => {
        event.preventDefault();
        // Validate department name
        if (!formData.panna_size.trim()) {
            setErrors({ panna_size: 'Panna Size is required' });
            return;
        }

        dispatch(updatePannaEntry(formData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                toast.success("Panna Updated Successful");
                window.close();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });


    };




    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement


    return (
        <>
            <div style={{ margin: '1%' }}>
                <h2>Panna Edit</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>
                            <Grid container spacing={2}>

                                <Grid item xs={12} md={6} >
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='panna_size' >Panna Entry:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <TextField
                                                    id='panna_size'
                                                    name='panna_size'
                                                    value={formData.panna_size}
                                                    onChange={handleInputChange}
                                                    inputProps={{ style: styled.input }}
                                                    sx={inputStyles}
                                                />
                                                {errors.panna_size && <FormHelperText style={errorStyles}>{errors.panna_size}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default PannaEdit;
